import api from './api';
import router from '../../router';

const pathRegex = /^\/qualification/;

const state = {
	error: null,
	qualifications: [],
};

const getters = {
	getQualificationById: (state) => (id) => {
		return state.qualifications.find((q) => q._id === id);
	},
	qualificationNames: (state) => state.qualifications.map((q) => q.name),
};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	removeError(state) {
		state.error = null;
	},

	setQualifications(state, qualifications) {
		state.qualifications = qualifications;
	},

	addQualification(state, qualification) {
		state.qualifications.push(qualification);
	},

	updateQualification(state, qualification) {
		const qualificationIndex = state.qualifications.findIndex((q) => q._id === qualification.id);
		if (qualificationIndex != -1) {
			state.qualifications[qualificationIndex].name = qualification.name;
			state.qualifications[qualificationIndex].description = qualification.description;
		}
	},

	setDeleted(state, { qualificationId, deleted }) {
		const qualification = state.qualifications.find((q) => q._id === qualificationId);
		if (qualification !== undefined) {
			qualification.deleted = deleted;
		}
	},
};

const actions = {
	async load({ commit }) {
		try {
			const qualifications = (await api.list()).data;
			commit('setQualifications', qualifications);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async create({ commit }, qualification) {
		try {
			const result = await api.create(qualification);
			commit('addQualification', result.data);
			return result.data;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async update({ commit }, qualification) {
		try {
			await api.update(qualification);
			commit('updateQualification', qualification);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async delete({ commit }, qualificationId) {
		try {
			await api.delete(qualificationId);
			commit('setDeleted', { qualificationId, deleted: true });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async restore({ commit }, qualificationId) {
		try {
			const result = await api.update({ id: qualificationId, deleted: false });
			commit('setDeleted', { qualificationId, deleted: false });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	removeError({ commit }) {
		commit('removeError');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
